import { BaseModalAction } from "./BaseModalAction";
import { BaseModalActions } from "./BaseModalActions";
import { BaseModalContent } from "./BaseModalContent";
import { BaseModalRoot } from "./BaseModalRoot";
import { BaseModalTitle } from "./BaseModalTitle";


export const BaseModal = {
    Action: BaseModalAction,
    Actions: BaseModalActions,
    Content: BaseModalContent,
    Root: BaseModalRoot,
    Title: BaseModalTitle,
}


// WEBPACK FOOTER //
// ./src/component/shared/base-modal/index.tsx